'use client'

// src/util/product.ts
var parseCmsSectionItem = ({
  item,
  locale
}) => {
  var _a, _b, _c;
  switch (item.__typename) {
    case "Artist":
      return {
        __typename: item.__typename,
        id: item.name,
        title: item.name,
        subtitle: item.subtitle,
        image: item.thumbnail
      };
    case "ContentCard": {
      const href = (_a = item.link) == null ? void 0 : _a.href;
      return {
        __typename: item.__typename,
        id: item.id,
        title: item.title,
        subtitle: item.subtitle,
        image: item.icon,
        description: item.description,
        contentList: (_b = item.contentListCollection) == null ? void 0 : _b.items.map((card) => ({
          __typename: "ContentCard",
          id: card.id,
          title: card.title,
          subtitle: card.subtitle,
          image: card.icon,
          description: card.description
        })),
        href: href ? ((_c = item.link) == null ? void 0 : _c.isExternal) || href.startsWith("http") ? href : `/${locale}${href.startsWith("/") ? "" : "/"}${href}` : void 0
      };
    }
    default:
      return null;
  }
};
var resolveProductUrlType = (entityType) => {
  const slug = typeof entityType === "string" ? entityType : entityType == null ? void 0 : entityType.slug;
  switch (slug) {
    case "event":
      return "events";
    case "season":
      return "seasons";
    case "restaurant":
      return "restaurants";
    case "experience":
    case "court":
      return "experiences";
    case "auction":
      return "auctions";
    case "package":
      return "packages";
    default:
      return null;
  }
};
var resolveProductFavoriteType = (entityType) => {
  const slug = typeof entityType === "string" ? entityType : entityType.slug;
  return `${slug[0].toUpperCase()}${slug.slice(1)}`;
};
var createProductItemHref = (product) => {
  var _a, _b, _c, _d, _e;
  const urlType = resolveProductUrlType(product.entityType);
  const safeUrlType = urlType ? `/${urlType}/` : "/";
  const cleanSlug = ((_a = product.slug) == null ? void 0 : _a.startsWith("/")) ? product.slug.slice(1) : product.slug;
  const country = (_b = product.location) == null ? void 0 : _b.countryCode;
  if (!country) {
    return `${safeUrlType}${cleanSlug}`;
  }
  let href = `/${country}`;
  if ((_c = product.location) == null ? void 0 : _c.cityCode) {
    href += `/${product.location.cityCode}`;
  }
  if ((_d = product.category) == null ? void 0 : _d.slug) {
    if (!((_e = product.location) == null ? void 0 : _e.cityCode)) href += "/local";
    href += `/${product.category.slug}`;
    return `${href}${safeUrlType}${cleanSlug}`;
  }
  href += safeUrlType + cleanSlug;
  return href;
};
var resolveProductEventType = (action) => {
  switch (action == null ? void 0 : action.type) {
    case "default":
      return "internal";
    case "external":
      return "external";
    case "offline":
      return "offline";
    case "sold_out":
      return "sold_out";
    default:
      return void 0;
  }
};
var isResellProduct = (action) => (action == null ? void 0 : action.type) === "primary_resell" || (action == null ? void 0 : action.type) === "secondary_resell";

export {
  parseCmsSectionItem,
  resolveProductUrlType,
  resolveProductFavoriteType,
  createProductItemHref,
  resolveProductEventType,
  isResellProduct
};
//# sourceMappingURL=chunk-NY6K524K.mjs.map